import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  DnextRole,
  DoctorsNextService,
} from 'src/app/feature/doctors-next.service';
import { DoctorsNextRegisterStateService } from '../doctors-next-register-state.service';
import { DoctorsNextSelectDepartmentsComponent } from '../doctors-next-select-departments/doctors-next-select-departments.component';

@Component({
  selector: 'app-doctors-next-register-additional',
  templateUrl: './doctors-next-register-additional.component.html',
  styleUrls: [
    './doctors-next-register-additional.component.css',
    '../style/index.css',
    '../style/registration.css',
  ],
})
export class DoctorsNextRegisterAdditionalComponent implements OnInit {
  @Input()
  clientId!: string;

  industryTypes = [
    '医院・クリニック',
    '病院',
    '調剤薬局',
    'ドラッグストア',
    '介護施設',
    'その他',
  ];

  positions = ['経営職', '管理職', '経営職・管理職以外'];

  prefecutures = [
    '北海道',
    '青森県',
    '岩手県',
    '宮城県',
    '秋田県',
    '山形県',
    '福島県',
    '茨城県',
    '栃木県',
    '群馬県',
    '埼玉県',
    '千葉県',
    '東京都',
    '神奈川県',
    '新潟県',
    '富山県',
    '石川県',
    '福井県',
    '山梨県',
    '長野県',
    '岐阜県',
    '静岡県',
    '愛知県',
    '三重県',
    '滋賀県',
    '京都府',
    '大阪府',
    '兵庫県',
    '奈良県',
    '和歌山県',
    '鳥取県',
    '島根県',
    '岡山県',
    '広島県',
    '山口県',
    '徳島県',
    '香川県',
    '愛媛県',
    '高知県',
    '福岡県',
    '佐賀県',
    '長崎県',
    '熊本県',
    '大分県',
    '宮崎県',
    '鹿児島県',
    '沖縄県',
  ];

  years: string[] = [];

  /** 診療科・専門を設定する必要があるか否か */
  hasSpecialities = false;

  constructor(
    private dialog: MatDialog,
    private registerStateService: DoctorsNextRegisterStateService,
    private next: DoctorsNextService
  ) {}

  ngOnInit(): void {
    this.years = Array.from({ length: 100 }, (_, i) =>
      (new Date().getFullYear() - i).toString()
    );
  }

  get selected() {
    return this.registerStateService.selected;
  }

  click() {
    const role = this.selected.role;
    const dialog = this.dialog.open(DoctorsNextSelectDepartmentsComponent, {
      width: '720px',
      height: '80vh',
      disableClose: false,
      data: {
        role: role,
        selectedLabels: this.selected.departments,
        label: this.departmentLabel,
        clientId: this.clientId,
      },
    });
    dialog.afterClosed().subscribe((departments?: string[]) => {
      if (!departments) return;
      this.selected.departments = departments;
    });
  }

  onRoleChange(role: DnextRole) {
    this.selected.role = role;
    // 診療科・専門を取得する。１件も選択肢がない場合は、設定が必要とする
    this.next.getSpecialties(this.clientId, role).forEach((departments) => {
      this.hasSpecialities = departments.department_categories.length > 0;
    });
  }

  /** 免許取得年フォームを表示するか否か */
  get isShowLicenseYearForm(): boolean {
    const target = ['doctor'];
    return target.includes(this.selected.role || '');
  }

  get isDepartment(): boolean {
    return this.registerStateService.isDepartment;
  }

  get departmentLabel(): string {
    return this.registerStateService.departmentLabel;
  }

  get selectedDepartmentsLabel(): string {
    if (this.selected.departments.length === 0) return '未選択';
    return this.selected.departments.join('、');
  }

  _submit() {
    this.registerStateService.inputStep = 'confirm';
  }

  _back() {
    this.registerStateService.inputStep = 'base';
  }

  get isSubmittable() {
    // 診療科・専門を設定する必要がある場合、設定されていない場合は登録不可
    if (this.hasSpecialities) {
      if (this.selected.departments.length === 0) {
        return false;
      }
    }
    if (this.selected.role === 'doctor') {
      // 医師免許資格取得年月日が設定されていない場合は登録不可
      if (!this.selected.licenseAcquisitionYear) {
        return false;
      }
    }
    // 業種が設定されていない場合は登録不可
    if (!this.selected.industryType) {
      return false;
    }
    // 所属医療機関が設定されていない場合は登録不可
    if (!this.selected.affiliation) {
      return false;
    }

    // 都道府県が設定されていない場合は登録不可
    if (!this.selected.pref) {
      return false;
    }

    // 役職が設定されていない場合は登録不可
    if (!this.selected.position) {
      return false;
    }
    return true;
  }
}
